module.exports = __webpack_public_path__ + "img/4.f0167b6e.jpg";